import(/* webpackMode: "eager" */ "/workspace/components/layout/Academiccard.jsx");
import(/* webpackMode: "eager" */ "/workspace/custom/CustomBreadcrumbs.jsx")